import {Device} from '@twilio/voice-sdk';
import store from '.';
import API from '../shared/forms/API';

/* Static variable for Device */
let device;

const initialState = {
  isReady: false,
  isCalling: false,
  to: null,
  time: 0
};

const actions = {
  CONNECTED: 'PHONE_CONNECTED',
  DISCONNECTED: 'PHONE_DISCONNECTED',
  READY: 'PHONE_READY',
  ERROR: 'PHONE_ERROR',
  CONNECTING: 'PHONE_CONNECTING',
  DISCONNECTING: 'PHONE_DISCONNECTING',
  TICK: 'PHONE_TICK'
};

const onDeviceRegistered = () => {
  console.log('Twilio.Device.ready');
  store.dispatch({
    type: actions.READY
  });
};

const onTwilioError = (error) => {
  alert(error.message);
  console.error(error);
  store.dispatch({
    type: actions.ERROR,
    error
  });
};

const onTwilioAccept = () => {
  console.log('Twilio.Device.connect');
  store.dispatch({
    type: actions.CONNECTED
  });
};

const onTwilioDisconnect = () => {
  console.log('Twilio.Device.disconnect');
  store.dispatch({
    type: actions.DISCONNECTED
  });
};

const connect = async () => {
  const To = store.getState().phone.to;

  const call = await device.connect({
    params: {
      To,
      CallerUserId: store.getState().user.uuid
    }
  });

  call.on('accept', onTwilioAccept);
  call.on('disconnect', onTwilioDisconnect);
  call.on('cancel', onTwilioDisconnect);
  call.on('error', onTwilioError);

  return call;
}

const getTwilioToken = async () => {
  const api = new API();
  return api
    .fetch('twilio/token')
    .then((response) => response.json())
    .then((json) => json.token);
};

const onTokenWillExpire = async () => {
  try {
    const token = await getTwilioToken();
    device.updateToken(token);
  } catch (error) {
    store.dispatch({
      type: actions.ERROR,
      error
    });
  }
};

const setup = async (dispatch) => {
  try {
    const token = await getTwilioToken();
    console.log('Setup');

    device = new Device(token, {logLevel: 2});
    device.on(Device.EventName.Registered, onDeviceRegistered);
    device.on(Device.EventName.Error, onTwilioError);
    device.on(Device.EventName.TokenWillExpire, onTokenWillExpire)

    return await device.register();
  } catch (error) {
    dispatch({
      type: actions.ERROR,
      error
    });
  }
};

let callTimeInterval = null;

const startCallTimeInterval = () => {
  callTimeInterval = setInterval(() => {
    store.dispatch({
      type: actions.TICK
    });
  }, 1000);
};

const stopCallTimeInterval = () => {
  clearInterval(callTimeInterval);
};

export const callAction = (to) => {
  return async (dispatch, getState) => {
    dispatch({type: actions.CONNECTING, to});

    if (getState().phone.isReady) {
      await connect();
    } else {
      await setup(dispatch);
      await connect();
    }
  };
};

export const hangupAction = () => {
  device.disconnectAll();
  return {
    type: actions.DISCONNECTING
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.READY:
      return {...state, isReady: true};
    case actions.ERROR:
      return initialState;
    case actions.TICK:
      return {...state, time: state.time + 1};
    case actions.CONNECTED:
      startCallTimeInterval();
      return {...state, to: null};
    case actions.DISCONNECTED:
      stopCallTimeInterval();
      return {...state, isCalling: false, time: 0};
    case actions.CONNECTING:
      return {...state, isCalling: true, to: action.to};
    default:
      return state;
  }
};
